// "Enter sniper mode" on a game row — the target glyph beside the bookmark
// in the Date cell. Navigates to the STANDALONE /sniper/:gameKey screen
// (its own window chrome-free page, no broad feed — just this game's lane +
// the sniper pad).
//
// Self-gating like SaveGameToggle: renders null unless the viewer passes
// canAccessSniper (admin, or the fail-closed traderRules.sniperEnabled
// grant) AND the row has both Kalshi legs (the sniper attaches to a binary
// Kalshi pair; series/tennis-tournament fabrications don't qualify).
//
// Click isolation is load-bearing (#651 family): the row's onClick expands
// ladders and a sibling <Link> opens game detail — this button must trigger
// neither. Same 12px/p-0.5 geometry as its two neighbors.

import { Target } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSniperAccess } from '@/hooks/useSniperAccess';
import { larryLegsOf } from '@/views/Cockpit/larryMatch';
import type { GameRow } from './types';

export function SniperTargetLink({ game }: { game: GameRow }) {
  const canSnipe = useSniperAccess();
  const navigate = useNavigate();
  if (!canSnipe || larryLegsOf(game) == null) return null;

  const matchup = `${game.awayCode} @ ${game.homeCode}`;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        navigate(`/sniper/${encodeURIComponent(game.key)}`);
      }}
      aria-label={`Enter sniper mode on ${matchup}`}
      title="Enter sniper mode — standalone single-game screen"
      className="text-muted-foreground/40 hover:text-primary shrink-0 rounded p-0.5 transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-500"
    >
      <Target size={12} />
    </button>
  );
}
